import { baseApi } from 'shared/api/baseApi'
import { CMS_SETTINGS_TAG } from 'shared/api/tags'
import type {
    CMSGenerateUploadUrlResponse,
    CMSSettings,
    CMSUpdateSettingsRequest,
} from '../model/types'

export const cmsSettingsApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getCmsSettings: build.query<CMSSettings, { organizationId: string }>({
            query: ({ organizationId }) => ({
                url: `public/organizations/${organizationId}/cms-settings`,
                method: 'GET',
            }),
            providesTags: [CMS_SETTINGS_TAG],
        }),

        updateCmsSettings: build.mutation<
            CMSSettings,
            CMSUpdateSettingsRequest
        >({
            query: ({ organizationId, data }) => ({
                url: `cms-settings/${organizationId}`,
                method: 'PATCH',
                body: data,
            }),
            invalidatesTags: [CMS_SETTINGS_TAG],
        }),

        generateCmsSettingsUploadUrl: build.mutation<
            CMSGenerateUploadUrlResponse,
            { organizationId: string }
        >({
            query: ({ organizationId }) => ({
                url: `cms-settings/${organizationId}/photos/generate-upload-url`,
                method: 'POST',
            }),
        }),
    }),
})

export const {
    useGetCmsSettingsQuery,
    useUpdateCmsSettingsMutation,
    useGenerateCmsSettingsUploadUrlMutation,
} = cmsSettingsApi
